"use strict";

window.log = console.log;
window.π = {
  app: {
    head: {},
    helper: {},
    mixins: {},
    modules: {}
  },
  helper: {}
};;"use strict";

π.main = {
  refs: {
    window: $(window),
    document: $(document),
    html: $('html'),
    body: $('body'),
    main: $('#main'),
    header: $('#header'),
    footer: $('#footer'),
    navigation: $('#navigation'),
    aside: $('#aside')
  },
  config: {
    stats: false
  },
  device: {
    isMac: false,
    isWin: false,
    isLocal: false,
    isProduction: false,
    isTouch: 'ontouchstart' in window,
    isMobile: false,
    isApp: false,
    isIOSApp: false,
    isAndroidApp: false,
    isIOS: false,
    isIPad: false,
    isIOSChrome: false,
    isIOSFirefox: false,
    isIOSSafari: false,
    isAndroid: false,
    isAndroidNative: false,
    isAndroidChrome: false,
    isAndroidDeprecated: false,
    isIE: false,
    isltIE9: false,
    isltIE10: false,
    isltIE11: false,
    isEdge: false,
    isSafari: false,
    isFirefox: false,
    isChrome: false,
    safariPopedIntitalState: false
  },
  window: {
    innerWidth: $(window).innerWidth(),
    innerHeight: $(window).innerHeight(),
    outerWidth: $(window).outerWidth(),
    outerHeight: $(window).outerHeight(),
    scrollTop: 0,
    scrollLeft: 0,
    scrollDir: {
      vertical: 'down',
      horizontal: 'right'
    },
    srollHistory: {
      vertical: [],
      horizontal: []
    },
    scrollDisabled: false,
    scrollPreventEventOnce: false,
    scrollPreventHorizontal: true,
    mousewheelDir: undefined,
    onScroll: false,
    mouseOffsetX: undefined,
    mouseOffsetY: undefined,
    mouseClientX: undefined,
    mouseClientY: undefined,
    usesTrackPad: false,
    location: {
      hash: location['hash']
    }
  },
  document: {
    width: $(document).width(),
    height: $(document).height()
  },
  constants: {
    duration: {
      resizeTimeout: 200,
      DOMNodeInsertedTimeout: 200,
      scrollTimeout: 300
    }
  },
  functions: {
    resizeTimeout: false,
    popstateTimeout: false,
    DOMNodeInsertedTimeout: false,
    scrollTimeout: false,
    observerInterval: false
  }
};;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {},
      PRIV = {
    init: function init() {
      π.main.refs.body.on({
        'click': PRIV.onClickControl
      }, '.division-controls .btn');
      π.main.refs.body.on({
        'click': PRIV.onClickStep
      }, '.division-header .step span');
      π.main.refs.body.find('select').on({
        'ce.select2-init': PRIV.onInitSelect
      });
      π.main.refs.body.find('.row, h1, h2, h3').on({
        'focusin': PRIV.onFocusinRow
      });
      π.main.refs.body.find('.validate-wrapper').on({
        'ce.validate': PRIV.onValidateWrapper
      });
    },
    createSteps: function createSteps() {
      var headlines = _refs['self'].find('.division-headline'),
          length = gl(headlines),
          width = (100 / length).toFixed(3);

      var html = '<header class="division-header">';
      _vars['length'] = length;
      headlines.each(function (i) {
        var that = $(this);
        html += '<div class="step" style="min-width:' + width + '%" data-step="' + (i + 1) + '">' + '<span>' + that.text() + '</span>' + '</div>';
        that.remove();
      });
      html += '</header>';

      _refs['self'].prepend(html);
    },
    createControls: function createControls() {
      var html = '<div class="division-controls">' + '<div class="btn show prev">' + i18n[11] + '</div>' + '<div class="btn show next">' + i18n[12] + '</div>' + '</div>';

      _refs['buttons'].prepend(html);

      _refs['self'].append('<div class="divisions-clear"></div>');
    },
    moveTo: function moveTo(i) {
      _refs['self'].find('.divisions-wrapper .division-wrapper').removeClass('active').first().css({
        'margin-left': (i - 1) * -100 + '%'
      });

      _refs['self'].find('.divisions-wrapper .division-wrapper').eq(i - 1).addClass('active');

      _vars['current'] = i;
      PRIV.setHeight();
      PRIV.updateStepsActiveState();
      PRIV.updateControlsActiveState();
      PRIV.updateSubmitVisibility();
    },
    validate: function validate(step, callback) {
      var validateWrapper,
          valid = true;

      for (var i = 0; i < step && valid; i++) {
        validateWrapper = _refs['self'].find('.division-wrapper').eq(i);
        π.helper.validate(validateWrapper);

        if (validateWrapper.hasClass('error-flag')) {
          valid = false;
        }
      }

      if (valid) {
        _refs['self'].removeClass('error-flag');
      } else {
        _refs['self'].addClass('error-flag');
      }

      callback(valid, i);
    },
    updateStepsActiveState: function updateStepsActiveState() {
      _refs['self'].find('.division-header .step').removeClass('active');

      _refs['self'].find('.division-header .step[data-step="' + _vars['current'] + '"]').addClass('active');
    },
    updateControlsActiveState: function updateControlsActiveState() {
      if (_vars['current'] == 1) {
        _refs['self'].find('.division-controls .btn.prev').addClass('disabled');
      } else {
        _refs['self'].find('.division-controls .btn.prev').removeClass('disabled');
      }

      if (_vars['current'] == _vars['length']) {
        _refs['self'].find('.division-controls .btn.next').addClass('disabled');
      } else {
        _refs['self'].find('.division-controls .btn.next').removeClass('disabled');
      }
    },
    updateSubmitVisibility: function updateSubmitVisibility() {
      if (_vars['current'] == _vars['length']) {
        _refs['buttons'].find('[type=submit]').addClass('show');
      } else {
        _refs['buttons'].find('[type=submit]').removeClass('show');
      }
    },
    setHeight: function setHeight() {
      var divisionsWrapper = _refs['self'].find('.divisions-wrapper');

      divisionsWrapper.height(parseInt(divisionsWrapper.find('.division-wrapper.active').height() + 10));
    },
    onClickControl: function onClickControl() {
      var that = $(this);

      if (!that.hasClass('disabled')) {
        if (that.hasClass('prev')) {
          PRIV.moveTo(_vars['current'] - 1);
        } else {
          PRIV.validate(_vars['current'], function (valid) {
            if (valid) {
              PRIV.moveTo(_vars['current'] + 1);
            }
          });
        }
      }
    },
    onClickStep: function onClickStep() {
      var step = $(this).closest('.step').data('step');
      PRIV.validate(step - 1, function (valid, lastValidStep) {
        if (valid) {
          PRIV.moveTo(step);
        } else {
          PRIV.moveTo(lastValidStep);
        }
      });
    },
    onInitSelect: function onInitSelect() {
      PRIV.setHeight();
    },
    onFocusinRow: function onFocusinRow() {
      var that = $(this),
          activeElement = $(document['activeElement']);

      if (!activeElement.closest('.division-wrapper').hasClass('active')) {
        activeElement.closest('.divisions-wrapper').find('.division-wrapper.active').find('input, select, textarea').first().focus();
      } else if (['SPAN', 'A'].includes(document['activeElement']['tagName'])) {
        that.next('.row').find('input, select, textarea').first().focus();
      }
    },
    onValidateWrapper: function onValidateWrapper() {
      var form = this['tagName'] == 'FORM' ? $(this) : $(this).closest('form');

      if (gl(form.find('.error-flag'))) {
        form.addClass('error-flag');
      } else {
        form.removeClass('error-flag');
      }
    }
  },
      _refs = {
    self: $('.divisions'),
    buttons: $('.button-wrapper')
  },
      _vars = {
    length: 0,
    current: 1
  }; // PUBLIC

  return _refs['self']['length'] ? {
    // methods
    _divisions: {
      init: function init() {
        PRIV.init();
        PRIV.createSteps();
        PRIV.createControls();
        PRIV.moveTo(1);
      }
    }
  } : undefined;
}());;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {
    token: 'O7kHlMbMtonPlGExXARcyZ4HsUmxYzK0'
  },
      PRIV = {
    setBodyClass: function setBodyClass() {
      if (gv(π.helper.getQueryObject(), 'origin', false)) {
        π.main.refs.body.addClass('iframe');
      }
    },
    setEventListener: function setEventListener() {
      $(document.getElementById('resizer')['contentWindow']).on({
        'resize': PRIV.onResize
      });
    },
    postHeight: function postHeight() {
      var origin = gv(π.helper.getQueryObject(), 'origin', false);

      if (origin) {
        var data = {
          'token': CONF['token'],
          'height': π.main.refs.body.height()
        },
            message = JSON.stringify(data);
        parent.postMessage(message, decodeURIComponent(origin));
      }
    },
    onResize: function onResize() {
      PRIV.postHeight();
    }
  },
      _refs = {},
      _vars = {}; // PUBLIC

  return {
    // methods
    _iframe: {
      init: function init() {
        PRIV.setBodyClass();
        PRIV.setEventListener();
        PRIV.postHeight();
      }
    }
  };
}());;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {},
      PRIV = {
    show: function show() {
      setTimeout(function () {
        return $('#loading').fadeIn();
      }, 1000);
    },
    onSubmit: function onSubmit() {
      _vars['readyForSubmit'] = true;
    },
    onValidate: function onValidate() {
      if (_vars['readyForSubmit'] && !$(this).hasClass('error-flag')) {
        PRIV.show();
      } else {
        _vars['readyForSubmit'] = false;
      }
    },
    onValidationFailed: function onValidationFailed() {
      _vars['readyForSubmit'] = false;
    }
  },
      _refs = {},
      _vars = {
    readyForSubmit: false
  }; // PUBLIC

  return {
    // methods
    _loading: {
      init: function init() {
        π.main.refs.body.find('form').on({
          'submit': PRIV.onSubmit
        });
        π.main.refs.body.find('form').on({
          'ce.validate': PRIV.onValidate
        });
        π.main.refs.body.find('form').on({
          'ce.validation-failed': PRIV.onValidationFailed
        });
      }
    }
  };
}());;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {},
      PRIV = {
    getCookies: function getCookies(scope) {
      var cookies = PRIV.getDataObject(scope);
      cookies = PRIV.getDecompressed(cookies);
      cookies = PRIV.getJSONParsed(cookies);
      return cookies;
    },
    getDataObject: function getDataObject(scope) {
      var cookies = {};

      _.each(scope['cookie'].split('; '), function (cookie) {
        var split = cookie.split('=');
        cookies[split[0]] = split[1];
      });

      return cookies;
    },
    getDecompressed: function getDecompressed(cookies) {
      _.each(cookies, function (value, key) {
        cookies[key] = π.helper.getDecompressedString(value);
      });

      return cookies;
    },
    getJSONParsed: function getJSONParsed(cookies) {
      if (π.helper.isObject(cookies) || _.isArray(cookies)) {
        _.each(cookies, function (cookie, key) {
          cookies[key] = PRIV.getJSONParsed(cookie, false);
        });
      } else if (typeof cookies == 'string') {
        cookies = π.helper.getParsedJSON(cookies, false);
      }

      return cookies;
    }
  },
      _refs = {},
      _vars = {}; // PUBLIC

  return {
    // methods
    setCookie: function setCookie(keys, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof keys == 'string') {
        var scope = options['scope'] || document,
            expires = π.helper.getDateIn(options['days'] || 365, 'days'),
            prime = keys.split('.').shift();

        if (keys.includes('.')) {
          var stock = gv(PRIV.getCookies(scope), prime, false);

          if (!π.helper.isObject(stock)) {
            stock = {};
          }

          _.set(stock, keys.replace(prime + '.', ''), data);

          data = stock;
        }

        data = π.helper.getStringifiedJSON(data);
        data = options['compress'] ? π.helper.getCompressedString(data) : data;
        scope['cookie'] = prime + '=' + data + '; expires=' + expires + '; expires=' + expires + '; path=/';
      } else {
        console.warn('keys must be a string');
      }
    },
    getCookie: function getCookie(keys) {
      var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

      if (typeof keys == 'string') {
        if (keys.includes('.')) {
          var prime = keys.split('.').shift(),
              path = keys.replace(prime, ''),
              key = path.substr(1, path['length']);
          return _.map([key], _.propertyOf(gv(PRIV.getCookies(scope), prime, false))).shift();
        } else {
          return gv(PRIV.getCookies(scope), keys, false);
        }
      } else {
        console.warn('keys must be a string');
        return undefined;
      }
    },
    getCookies: function getCookies() {
      var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
      return PRIV.getCookies(scope);
    },
    deleteCookie: function deleteCookie(keys) {
      var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof keys == 'string') {
        var expires = new Date(Date.now() - 1).toUTCString();
        keys = keys.split('.');

        if (gl(keys) == 1) {
          scope['cookie'] = keys[0] + '=; expires=' + expires + '; path=/';
        } else {
          var prime = keys.shift(),
              stock = gv(PRIV.getCookies(scope), prime, false);

          _.unset(stock, keys);

          if (gl(stock)) {
            π.helper.setCookie(prime, stock, {
              compress: options['compress']
            });
          } else {
            scope['cookie'] = prime + '=; expires=' + expires + '; path=/';
          }
        }
      } else {
        console.warn('keys must be a string');
      }
    }
  };
}());;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {},
      PRIV = {
    arrayMoveMutate: function arrayMoveMutate(array, from, to) {
      array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
    }
  },
      _refs = {},
      _vars = {}; // PUBLIC

  return {
    // methods
    applyMethod: function applyMethod(root, keys, args) {
      var thisArg = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (typeof root == 'function') {
        return root.apply(thisArg, _.castArray(args));
      } else if (π.helper.isFunction(root, keys)) {
        return π.helper.applyMethod(gv(root, keys), undefined, args, thisArg);
      }
    },
    applyMethods: function applyMethods(root, keysArray, methodNamesArray, args) {
      var thisArg = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var methods = π.helper.getMemory(options['cache']);

      if (_.isArray(methods)) {
        _.each(methods, function (method) {
          if (typeof method == 'function') {
            method.apply(thisArg, args);
          }
        });
      } else {
        keysArray = _.castArray(keysArray);
        methodNamesArray = _.castArray(methodNamesArray);

        if (options['cache']) {
          π.helper.setMemory(options['cache'], []);
        }

        _.each(keysArray, function (keys) {
          if (!keys.startsWith('!')) {
            var scope = gv(root, keys, false);

            _.each(scope, function (node, key) {
              if (typeof node == 'object' && !keysArray.includes('!' + key)) {
                _.each(methodNamesArray, function (methodName) {
                  _.each(methodName.split('|'), function (methodName) {
                    if (π.helper.isFunction(node, methodName)) {
                      if (options['cache']) {
                        π.helper.pushMemory(options['cache'], gv(node, methodName), {
                          'uniq': true
                        });
                      }

                      π.helper.applyMethod(node, methodName, args, thisArg);
                      return false;
                    }
                  });
                });
              }
            });
          }
        });
      }
    },
    moveArray: function moveArray(array, from, to) {
      if (Array.isArray(array) && typeof from == 'number' && typeof to == 'number') {
        array = array.slice();
        PRIV.arrayMoveMutate(array, from, to);
      }

      return array;
    },
    isTrue: function isTrue(root, keys) {
      if (π.helper.isObject(root)) {
        if (typeof keys == 'string') {
          return _.map([keys], _.propertyOf(root)).shift() === true;
        } else {
          return false;
        }
      } else {
        return root === true;
      }
    },
    isFalse: function isFalse(root, keys) {
      if (π.helper.isObject(root)) {
        if (typeof keys == 'string') {
          return _.map([keys], _.propertyOf(root)).shift() === false;
        } else {
          return true;
        }
      } else {
        return root === false;
      }
    },
    isBoolean: function isBoolean(root, keys) {
      if (π.helper.isObject(root)) {
        if (typeof keys == 'string') {
          return _.isBoolean(_.map([keys], _.propertyOf(root)).shift());
        } else {
          return false;
        }
      } else {
        return typeof root == 'boolean';
      }
    },
    isNumber: function isNumber(root, keys) {
      if (π.helper.isObject(root)) {
        if (typeof keys == 'string') {
          return _.isNumber(_.map([keys], _.propertyOf(root)).shift());
        } else {
          return true;
        }
      } else {
        return _.isNumber(root);
      }
    },
    isString: function isString(root, keys) {
      if (π.helper.isObject(root)) {
        if (typeof keys == 'string') {
          return _.isString(_.map([keys], _.propertyOf(root)).shift());
        } else {
          return true;
        }
      } else {
        return _.isString(root);
      }
    },
    isArray: function isArray(root, keys) {
      if (π.helper.isObject(root) && typeof keys == 'string') {
        return _.isArray(_.map([keys], _.propertyOf(root)).shift());
      } else {
        return _.isArray(root);
      }
    },
    isObject: function isObject(root, keys) {
      if (_.isObject(root) && !_.isFunction(root)) {
        if (typeof keys == 'string') {
          var val = _.map([keys], _.propertyOf(root)).shift();

          return _.isObject(val) && !_.isArray(val) && !_.isFunction(val);
        } else {
          return _.isObject(root) && !_.isArray(root);
        }
      } else {
        return false;
      }
    },
    isFunction: function isFunction(root, keys) {
      if (π.helper.isObject(root) && typeof keys == 'string') {
        return _.isFunction(_.map([keys], _.propertyOf(root)).shift());
      } else {
        return _.isFunction(root);
      }
    },
    isJQueryObject: function isJQueryObject(that) {
      return that instanceof jQuery && that['length'] > 0;
    },
    isRegExMatch: function isRegExMatch(val, regex, warn) {
      if (typeof val == 'string') {
        try {
          var match = val.match(new RegExp(regex));
          return match ? match[0] === val : false;
        } catch (e) {
          if (warn !== false) {
            console.error('no valid regex');
          }

          return false;
        }
      } else {
        return false;
      }
    },
    setValue: function setValue(root, keys, value) {
      if (typeof root == 'object' && typeof keys == 'string' && keys['length']) {
        _.set(root, keys, value);
      }

      return root;
    },
    getValue: function getValue(root, keys, warn) {
      if (π.helper.isObject(root) && typeof keys == 'string') {
        try {
          var val = _.map([keys], _.propertyOf(root)).shift();

          if (warn !== false && val === undefined) {
            console.warn('no value for: ' + keys);
          }

          return val;
        } catch (err) {
          return undefined;
        }
      } else {
        return root;
      }
    },
    getLength: function getLength(root, keys) {
      var value = gv(root, keys, false);

      if (typeof value == 'string' || _.isArray(value) || value instanceof jQuery) {
        return value['length'];
      } else if (π.helper.isObject(value)) {
        return Object.keys(value)['length'];
      } else {
        return undefined;
      }
    },
    getValueByPrefix: function getValueByPrefix(object, prefix) {
      for (var property in object) {
        if (object.hasOwnProperty(property) && property.toString().startsWith(prefix)) {
          return object[property];
        }
      }
    },
    getKeyWithPrefix: function getKeyWithPrefix(object, prefix) {
      for (var property in object) {
        if (object.hasOwnProperty(property) && property.toString().startsWith(prefix)) {
          return property;
        }
      }
    },
    getExtendedRoot: function getExtendedRoot(root, value) {
      if (root) {
        if (typeof root == 'string') {
          root = [root];
        }

        root.push(value);
      } else {
        root = value;
      }

      return root;
    }
  };
}());;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {},
      PRIV = {
    // methods
    init: function init() {
      PRIV.upload.init();
      PRIV.select.init();
      PRIV.uniform.init();
      PRIV.textarea.init();
      PRIV.validation.init();
      PRIV.placeholder.init();
    },
    // objects
    upload: {
      init: function init() {
        π.main.refs.body.find("form input[type=file]:not(.initialized)").addClass("initialized").on({
          change: PRIV.upload.onChangeFile
        });
      },
      onChangeFile: function onChangeFile(e) {
        var that = $(this),
            fileReader = new FileReader();

        fileReader.onload = function (e) {
          if (e["total"] > that.data("size") * 1000) {
            that.data("correct-size", false);
            PRIV.validation.passed.extension(that, "file", false);
            PRIV.validation.toggle(that, false);
          } else {
            that.data("correct-size", true);
            PRIV.validation.passed.extension(that, "file", true);
            PRIV.validation.toggle(that, true);
          }

          that.closest(".form-box").find(".file").text(that.val().split("fakepath\\")[1] + " (" + parseInt(e["total"] / 1000) + "kb)");
        };

        fileReader.readAsDataURL(this["files"][0]);
      }
    },
    select: {
      init: function init() {
        π.main.refs.body.find("form select:not(.initialized)").each(function () {
          var that = $(this),
              width = window.getComputedStyle(that[0], null).getPropertyValue("width"),
              options = {
            theme: "classic",
            width: "no"
          };

          if (width != "100%") {
            options["width"] = width;
          }

          if (that.hasClass("no-search")) {
            options["minimumResultsForSearch"] = -1;
          }

          if (that.hasClass("tags")) {
            options["tags"] = true;
            options["tokenSeparators"] = [",", " "];
          }

          if (typeof that.data("max") != "undefined") {
            options["maximumSelectionLength"] = that.data("max");
          }

          if (typeof that.data("placeholder") != "undefined") {
            options["placeholder"] = that.data("placeholder");
            options["allowClear"] = true;
          }

          that.addClass("initialized").select2(options).on({
            "select2:select": PRIV.select.onSelect,
            "select2:close": PRIV.select.onClose
          });
          that.trigger("ce.select2-init");

          if (this.getAttribute("data-focus") != null) {
            that.removeAttr("data-focus").select2("focus");
          }
        });
      },
      onSelect: function onSelect() {
        if (π.main["device"]["isTouch"]) {
          $(document["activeElement"]).blur();
        }
      },
      onClose: function onClose() {
        $(this).trigger("ce.select2-close");
      }
    },
    uniform: {
      // methods
      init: function init() {
        PRIV.uniform.checkbox.init();
        PRIV.uniform.radio.init();
        PRIV.uniform.upload.init();
      },
      // objects
      checkbox: {
        init: function init() {
          π.main.refs.body.find(".uniform input[type=checkbox]:not(.initialized)").addClass("initialized").on({
            change: PRIV.uniform.checkbox.onChange
          }).each(PRIV.uniform.checkbox.set);
        },
        set: function set() {
          if (this["checked"]) {
            $(this).closest(".uniform").addClass("uniform-checked");
          } else {
            $(this).closest(".uniform").removeClass("uniform-checked");
          }
        },
        onChange: function onChange() {
          π.main.refs.body.find(".uniform input").each(PRIV.uniform.checkbox.set);
        }
      },
      radio: {
        init: function init() {
          π.main.refs.body.find(".uniform input[type=radio]:not(.initialized)").addClass("initialized").on({
            change: PRIV.uniform.radio.onChange
          }).each(PRIV.uniform.radio.set);
        },
        set: function set() {
          if (this["checked"]) {
            $(this).closest(".uniform").addClass("uniform-checked");
          } else {
            $(this).closest(".uniform").removeClass("uniform-checked");
          }
        },
        onChange: function onChange() {
          π.main.refs.body.find(".uniform input").each(PRIV.uniform.radio.set);
        }
      },
      upload: {
        init: function init() {
          π.main.refs.body.find(".uniform.uniform-upload .btn:not(.initialized)").addClass("initialized").on({
            click: PRIV.uniform.upload.onClick
          });
        },
        onClick: function onClick() {
          $(this).parent().find("input").trigger("click");
        }
      }
    },
    textarea: {
      init: function init() {
        π.main.refs.body.find("form textarea.wysiwyg:not(.initialized)").each(function () {
          var that = $(this),
              options = {
            btns: [["undo", "redo", "link"]],
            autogrow: true,
            removeformatPasted: true
          };
          that.addClass("initialized").trumbowyg(options).on("tbwblur", PRIV.textarea.onBlur);
        });
      },
      onBlur: function onBlur(e) {
        var that = $(this);
        that.html(that.trumbowyg("html")).trigger("ce.blur");
      }
    },
    validation: {
      init: function init() {
        π.main.refs.body.on({
          "submit.validate-wrapper": PRIV.validation.check
        }, ".validate-wrapper");
        π.main.refs.body.on({
          "keyup.validate-wrapper.validate-text": PRIV.validation.check
        }, ".validate-wrapper .validate-text");
        π.main.refs.body.on({
          "blur.validate-wrapper.validate-text": PRIV.validation.check
        }, ".validate-wrapper .validate-text");
        π.main.refs.body.on({
          "keyup.validate-wrapper.validate-email": PRIV.validation.check
        }, ".validate-wrapper .validate-email");
        π.main.refs.body.on({
          "blur.validate-wrapper.validate-email": PRIV.validation.check
        }, ".validate-wrapper .validate-email");
        π.main.refs.body.on({
          "keyup.validate-wrapper.validate-url": PRIV.validation.check
        }, ".validate-wrapper .validate-url");
        π.main.refs.body.on({
          "blur.validate-wrapper.validate-url": PRIV.validation.check
        }, ".validate-wrapper .validate-url");
        π.main.refs.body.on({
          "keyup.validate-wrapper.validate-slug": PRIV.validation.check
        }, ".validate-wrapper .validate-slug");
        π.main.refs.body.on({
          "blur.validate-wrapper.validate-slug": PRIV.validation.check
        }, ".validate-wrapper .validate-slug");
        π.main.refs.body.on({
          "keyup.validate-wrapper.validate-json": PRIV.validation.check
        }, ".validate-wrapper .validate-json");
        π.main.refs.body.on({
          "blur.validate-wrapper.validate-json": PRIV.validation.check
        }, ".validate-wrapper .validate-json");
        π.main.refs.body.on({
          "keyup.validate-wrapper.validate-number": PRIV.validation.check
        }, ".validate-wrapper .validate-number");
        π.main.refs.body.on({
          "blur.validate-wrapper.validate-number": PRIV.validation.check
        }, ".validate-wrapper .validate-number");
        π.main.refs.body.on({
          "keyup.validate-wrapper.validate-textarea": PRIV.validation.check
        }, ".validate-wrapper .validate-textarea");
        π.main.refs.body.on({
          "blur.validate-wrapper.validate-textarea": PRIV.validation.check
        }, ".validate-wrapper .validate-textarea");
        π.main.refs.body.on({
          "keyup.validate-wrapper.validate-password": PRIV.validation.check
        }, ".validate-wrapper .validate-password");
        π.main.refs.body.on({
          "blur.validate-wrapper.validate-password": PRIV.validation.check
        }, ".validate-wrapper .validate-password");
        π.main.refs.body.on({
          "change.validate-wrapper.validate-checkbox": PRIV.validation.check
        }, ".validate-wrapper .validate-checkbox");
        π.main.refs.body.on({
          "change.validate-wrapper.validate-radio": PRIV.validation.check
        }, ".validate-wrapper .validate-radio");
        π.main.refs.body.on({
          "change.validate-wrapper.validate-select": PRIV.validation.check
        }, ".validate-wrapper .validate-select");
        π.main.refs.body.on({
          "change.validate-wrapper.validate-file": PRIV.validation.check
        }, ".validate-wrapper .validate-file");
      },
      check: function check(e) {
        var that = $(this);

        if (that.hasClass("validate-wrapper")) {
          that.add(that.find(".validate-wrapper")).addClass("validate-wrapper-checked");

          if (PRIV.validation.passed.all(that)) {
            that.removeClass("error-flag");
          } else {
            π.helper.applyMethod(e, "preventDefault", undefined, e);
            that.addClass("error-flag");
            that.trigger("ce.validation-failed");
          }

          var captcha = that.find(".validate-captcha");

          if (gl(captcha) && !PRIV.validation.hasValidToken(captcha.val())) {
            π.helper.applyMethod(e, "preventDefault", undefined, e);
            π.helper.setCaptchaToken(captcha, function () {
              that.submit();
            });
          } else {
            that.trigger("ce.validate");
          }
        } else {
          var wrapper = that.closest(".validate-wrapper");

          if (wrapper.hasClass("validate-wrapper-checked")) {
            var valid = {
              text: that.hasClass("validate-text") ? PRIV.validation.passed.text(that) : true,
              email: that.hasClass("validate-email") ? PRIV.validation.passed.email(that) : true,
              url: that.hasClass("validate-url") ? PRIV.validation.passed.url(that) : true,
              slug: that.hasClass("validate-slug") ? PRIV.validation.passed.slug(that) : true,
              json: that.hasClass("validate-json") ? PRIV.validation.passed.json(that) : true,
              number: that.hasClass("validate-number") ? PRIV.validation.passed.number(that) : true,
              password: that.hasClass("validate-password") ? PRIV.validation.passed.password(that) : true,
              textarea: that.hasClass("validate-textarea") ? PRIV.validation.passed.textarea(that) : true,
              checkbox: that.hasClass("validate-checkbox") ? PRIV.validation.passed.checkbox(that) : true,
              radio: that.hasClass("validate-radio") ? PRIV.validation.passed.radio(that) : true,
              select: that.hasClass("validate-select") ? PRIV.validation.passed.select(that) : true,
              file: that.hasClass("validate-file") ? PRIV.validation.passed.file(that) : true
            };
            var error = false;

            for (var key in valid) {
              if (!valid[key]) {
                error = true;
              }
            }

            if (error || gl(wrapper.find(".error-flag"))) {
              wrapper.addClass("error-flag").trigger("ce.validate");
              π.helper.applyMethod(e, "preventDefault", undefined, e);
            } else {
              wrapper.removeClass("error-flag").trigger("ce.validate");
            }
          }
        }
      },
      toggle: function toggle(that, valid) {
        if (valid) {
          if (that.is("textarea") && that.prev().hasClass("mce-tinymce")) {
            that.removeClass("error-flag").prev().removeClass("error-flag");
          } else if (!that.hasClass("form-box") && that.closest(".form-box")["length"]) {
            that.closest(".form-box").removeClass("error-flag");
          } else {
            that.removeClass("error-flag");
          }
        } else {
          if (that.is("textarea") && that.prev().hasClass("mce-tinymce")) {
            that.addClass("error-flag").prev().addClass("error-flag");
          } else if (!that.hasClass("form-box") && that.closest(".form-box")["length"]) {
            that.closest(".form-box").addClass("error-flag");
          } else {
            that.addClass("error-flag");
          }
        }
      },
      hasValidToken: function hasValidToken(token) {
        return _vars["captchaToken"][token] + 1000 * 60 > Date.now();
      },
      setError: function setError(that, key, text) {
        that.data("validation-errors", π.helper.setValue(that.data("validation-errors") || {}, key, text));
      },
      getError: function getError(that, key) {
        return gv(that.data("validation-errors"), key, false);
      },
      getScope: function getScope(that, name) {
        var scope = that.closest(".validate-" + name + "-scope");

        if (!scope["length"]) {
          scope = that.closest(".validate-wrapper");
        }

        return scope;
      },
      getDataNumber: function getDataNumber(that, key) {
        var val = that.data(key);
        return !isNaN(val) && val !== "" ? Number(val) : NaN;
      },
      getNumber: function getNumber(that, key) {
        var val = that.data(key);
        return !isNaN(val) && val !== "" ? Number(val) : undefined;
      },
      getNormalizedString: function getNormalizedString(str) {
        // return _.trim(_.escape(str.replace(/\\/g, ""))).replace(
        //   /[\x00-\x1F\x7F-\xFF]/g,
        //   ""
        // )
        return _.trim(_.escape(str.replace(/\\/g, "")));
      },
      onDOMNodeInserted: function onDOMNodeInserted() {
        PRIV.validation.captcha.init();
      },
      // objects
      passed: {
        all: function all(wrapper) {
          var valid = true,
              keys = ["text", "email", "url", "slug", "json", "number", "password", "textarea", "checkbox", "radio", "select", "file"];
          keys.forEach(function (key) {
            if (!PRIV.validation.passed[key](wrapper)) {
              valid = false;
            }
          });
          return valid;
        },
        loop: function loop(that, key) {
          var valid = true;
          that.find(".validate-" + key).each(function () {
            if (!PRIV.validation.passed[key]($(this))) {
              valid = false;
            }
          });
          return valid;
        },
        chars: function chars(that) {
          var chars = that.data("chars"),
              valid = typeof chars == "undefined" || that.val().match(new RegExp("^[" + chars + "]*$")) !== null;

          if (!valid) {
            PRIV.validation.setError(that, "characters.allowed", chars);
          }

          return valid;
        },
        regex: function regex(that) {
          var regex = that.data("regex"),
              valid = !regex || π.helper.isRegExMatch(that.val(), regex);

          if (!valid) {
            PRIV.validation.setError(that, "regex.allowed", regex);
          }

          return valid;
        },
        length: function length(that) {
          var val = that.val(),
              length = that[0]["type"] == "number" ? val : val.length,
              opt = that.data("opt"),
              min = PRIV.validation.getDataNumber(that, "min"),
              max = PRIV.validation.getDataNumber(that, "max"),
              maxError = length > max;
          console.log(val.length);
          var minError;

          if (that[0]["type"] == "number") {
            minError = (!opt || length > 0) && (length < min || val == "");
          } else {
            minError = (!opt || length > 0) && (length < min || min === undefined && !length);
          }

          if (minError) {
            if (that[0]["type"] == "number") {
              PRIV.validation.setError(that, "length.min", typeof min == "number" ? min : 1);
            } else {
              PRIV.validation.setError(that, "length.min-chars", typeof min == "number" ? min : 1);
            }
          } else if (maxError) {
            if (that[0]["type"] == "number") {
              PRIV.validation.setError(that, "length.max", max);
            } else {
              PRIV.validation.setError(that, "length.max-chars", max);
            }
          }

          return !minError && !maxError;
        },
        words: function words(that) {
          var length = _.words(that.val())["length"],
              opt = that.data("opt"),
              min = PRIV.validation.getDataNumber(that, "min-words"),
              max = PRIV.validation.getDataNumber(that, "max-words"),
              minError = !opt && (length < min || min === undefined && length <= 0),
              maxError = length > max;

          if (minError) {
            PRIV.validation.setError(that, "length.min-words", typeof min == "number" ? min : 1);
          } else if (maxError) {
            PRIV.validation.setError(that, "length.max-words", max);
          }

          return !minError && !maxError;
        },
        completed: function completed(that) {
          var min = that.data("min");
          return (that.data("opt") || Number(min != "" ? min : undefined) === 0) && gl(that.val()) === 0;
        },
        extension: function extension(that, name, valid, completed) {
          if (π.helper.isFunction(π, "app.mixins.form._ext.validation." + name)) {
            return π.app.mixins.form._ext.validation[name](that, valid, completed);
          } else {
            return valid;
          }
        },
        text: function text(that) {
          var valid = true;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "text");
          } else {
            var completed = PRIV.validation.passed.completed(that);
            that.data("validation-errors", null);

            if (!completed) {
              valid = PRIV.validation.passed.length(that);
              valid = valid && PRIV.validation.passed.chars(that);
              valid = valid && PRIV.validation.passed.regex(that);
            }

            valid = PRIV.validation.passed.extension(that, "text", valid, completed);
            PRIV.validation.toggle(that, valid);
          }

          return valid;
        },
        email: function email(that) {
          var valid = true,
              match;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "email");
          } else {
            π.helper.setToLowerCase(that);
            var completed = PRIV.validation.passed.completed(that),
                val = that.val();
            that.data("validation-errors", null);

            if (!completed) {
              valid = PRIV.validation.passed.length(that);

              if (!validator.isEmail(val)) {
                valid = false;
                PRIV.validation.setError(that, "characters.format", "not valid");
              }
            }

            valid = PRIV.validation.passed.extension(that, "email", valid, completed);
            PRIV.validation.toggle(that, valid);
          }

          return valid;
        },
        url: function url(that) {
          var valid = true;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "url");
          } else {
            π.helper.setToLowerCase(that);
            var completed = PRIV.validation.passed.completed(that),
                val = that.val();
            that.data("validation-errors", null);

            if (!completed) {
              valid = PRIV.validation.passed.length(that);

              if (!val.startsWith("http") || !validator.isURL(val) || val.includes("://www") && val.match(/\./g)["length"] < 2) {
                valid = false;
                PRIV.validation.setError(that, "characters.format", "not valid");
              }
            }

            valid = PRIV.validation.passed.extension(that, "url", valid);
            PRIV.validation.toggle(that, valid);
          }

          return valid;
        },
        slug: function slug(that) {
          var valid = true,
              match;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "slug");
          } else {
            π.helper.setPointerPosition(that.val(that.val().toLowerCase()), that[0].selectionStart);
            var completed = PRIV.validation.passed.completed(that),
                val = that.val();
            that.data("validation-errors", null);

            if (!completed) {
              valid = PRIV.validation.passed.length(that);
              valid = (match = val.match(/^\/[a-z0-9-\/]*$/) !== null) && valid;

              if (!match) {
                PRIV.validation.setError(that, "characters.allowed", "[a-z0-9-/]");
              }
            }

            valid = PRIV.validation.passed.extension(that, "slug", valid);
            PRIV.validation.toggle(that, valid);
          }

          return valid;
        },
        json: function json(that) {
          var valid = true;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "json");
          } else {
            var completed = PRIV.validation.passed.completed(that),
                val = that.val();

            if (!completed) {
              valid = PRIV.validation.passed.length(that);
              valid = valid ? validator.isJSON(val) : valid;
            }

            valid = PRIV.validation.passed.extension(that, "json", valid, completed);
            PRIV.validation.toggle(that, valid);
          }

          return valid;
        },
        number: function number(that) {
          var valid = true;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "number");
          } else {
            var completed = PRIV.validation.passed.completed(that);
            that.data("validation-errors", null);

            if (!completed) {
              valid = PRIV.validation.passed.length(that);
            }

            valid = PRIV.validation.passed.extension(that, "number", valid);
            PRIV.validation.toggle(that, valid);
          }

          return valid;
        },
        password: function password(that) {
          var valid = true,
              match,
              equal;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "password");
          } else {
            var completed = PRIV.validation.passed.completed(that),
                scope = PRIV.validation.getScope(that, "password"),
                passwords = scope.find("input[type=password]"),
                val = that.val();
            that.data("validation-errors", null);

            if (!completed) {
              valid = PRIV.validation.passed.length(that);

              if (that.data("contain-number")) {
                valid = (match = val.match(/[0-9]/g) !== null) && valid;

                if (!match) {
                  PRIV.validation.setError(that, "characters.number", "missing");
                }
              }

              if (that.data("contain-uplow")) {
                valid = (match = val.match(/[A-Z]/g) !== null) && valid;

                if (!match) {
                  PRIV.validation.setError(that, "characters.upper case", "missing");
                }

                valid = (match = val.match(/[a-z]/g) !== null) && valid;

                if (!match) {
                  PRIV.validation.setError(that, "characters.lower case", "missing");
                }
              }

              if (that.data("contain-special")) {
                valid = (match = val.match(/[\^°!"§$%&\/()=?´`\[\]|{}€+*@#'<>,;.:\-_~]/g) !== null) && valid;

                if (!match) {
                  PRIV.validation.setError(that, "characters.special sign", "missing");
                }
              }

              if (passwords["length"] > 1) {
                passwords.each(function () {
                  if (!$(this).is(that)) {
                    var sibling = $(this);
                    valid = (equal = sibling.val() == val) && valid;

                    if (!equal) {
                      PRIV.validation.setError(that, "revision", "not equal");

                      if (!PRIV.validation.getError(sibling, "revision")) {
                        PRIV.validation.passed.password(sibling);
                      }
                    } else if (PRIV.validation.getError(sibling, "revision")) {
                      PRIV.validation.passed.password(sibling);
                    }
                  }
                });
              }
            }

            valid = PRIV.validation.passed.extension(that, "password", valid);
            passwords.each(function () {
              PRIV.validation.toggle($(this), valid);
            });
          }

          return valid;
        },
        textarea: function textarea(that) {
          var valid = true;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "textarea");
          } else {
            var completed = PRIV.validation.passed.completed(that);

            if (!completed) {
              valid = PRIV.validation.passed.length(that);
              valid = PRIV.validation.passed.words(that) && valid;
            }

            valid = PRIV.validation.passed.extension(that, "textarea", valid);
            PRIV.validation.toggle(that, valid);
          }

          return valid;
        },
        checkbox: function checkbox(that) {
          var valid = true;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "checkbox");
          } else {
            var scope = PRIV.validation.getScope(that, "checkbox");
            valid = false;
            scope.find("input[type=checkbox]").each(function () {
              var that = $(this);

              if (that.prop("checked")) {
                that.attr("checked", "checked");
                valid = true;
              } else {
                that.removeAttr("checked");
              }
            });
            scope.find("input[type=checkbox]").each(function () {
              PRIV.validation.toggle($(this).closest(".validate-checkbox-scope"), valid);
            });
            valid = PRIV.validation.passed.extension(that, "checkbox", valid);
            PRIV.validation.toggle(that, valid);
          }

          return valid;
        },
        radio: function radio(that) {
          var valid = true;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "radio");
          } else {
            var scope = PRIV.validation.getScope(that, "radio");
            valid = false;
            scope.find("input[type=radio]").each(function () {
              var that = $(this);

              if (that.prop("checked")) {
                that.attr("checked", "checked");
                valid = true;
              } else {
                that.removeAttr("checked");
              }
            });
            scope.find("input[type=radio]").each(function () {
              PRIV.validation.toggle($(this), valid);
            });
            valid = PRIV.validation.passed.extension(that, "radio", valid);
            PRIV.validation.toggle(that, valid);
          }

          return valid;
        },
        select: function select(that) {
          var valid = true;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "select");
          } else {
            var val = that.val(),
                maxTags = that.data("max-tags"),
                minTags = that.data("min-tags");
            valid = that.data("opt") || val && val["length"] ? true : false;
            valid = PRIV.validation.passed.extension(that, "select", valid);
            valid = valid && (isNaN(minTags) || !_.isArray(val) || val["length"] >= minTags);
            valid = valid && (isNaN(maxTags) || !_.isArray(val) || val["length"] <= maxTags);

            _.each(_.castArray(val), function (val) {
              var min = PRIV.validation.getDataNumber(that, "min-chars"),
                  max = PRIV.validation.getDataNumber(that, "max-chars");
              valid = valid && (isNaN(min) || val["length"] >= min) && (isNaN(max) || val["length"] <= max);

              if (valid) {
                var chars = that.data("chars");
                valid = valid && (typeof chars != "string" || val.match(new RegExp("^[" + chars + "]*$")) !== null);
              }
            });

            if (valid) {
              that.next().removeClass("error-flag");
            } else {
              that.next().addClass("error-flag");
            }
          }

          return valid;
        },
        file: function file(that) {
          var valid = true;

          if (that.hasClass("validate-wrapper")) {
            valid = PRIV.validation.passed.loop(that, "file");
          } else {
            that.data("validation-errors", null);

            if (!that.data("opt") && !gl(that.val())) {
              valid = false;
            }

            valid = valid ? that.data("correct-size") !== false : valid;
            valid = PRIV.validation.passed.extension(that, "file", valid);
            PRIV.validation.toggle(that, valid);
          }

          return valid;
        }
      }
    },
    placeholder: {
      init: function init() {
        π.main.refs.body.find("form input, form textarea").each(function () {
          var that = $(this);

          if (!gl(that.attr("placeholder"))) {
            var min = that.data("min"),
                max = that.data("max"),
                postFix = that.attr("type") == "number" ? "" : " characters";

            if (typeof min == "number" && typeof max == "number") {
              that.attr("placeholder", min + " to " + max + postFix);
            } else if (typeof min == "number") {
              that.attr("placeholder", "min. " + min + postFix);
            } else if (typeof max == "number") {
              that.attr("placeholder", "max. " + max + postFix);
            }
          }
        });
      }
    }
  },
      _refs = {},
      _vars = {
    captchaToken: {}
  }; // PUBLIC

  return {
    // methods
    validate: function validate(that) {
      π.helper.applyMethod(PRIV.validation.check, undefined, [{}], that);
    },
    parseJson: function parseJson(that) {
      that.val(JSON.stringify(JSON.parse(that.val()), undefined, 4));
    },
    setToLowerCase: function setToLowerCase(that) {
      if (!π.main["device"]["isMobile"]) {
        π.helper.setPointerPosition(that.val(that.val().toLowerCase()), that[0].selectionStart);
      } else {
        that.val(that.val().toLowerCase());
      }
    },
    setPointerPosition: function setPointerPosition(that, pos) {
      if (that["selectionStart"] != null && that["selectionEnd"] !== null) {
        that = $(that)[0];
        that["selectionStart"] = that["selectionEnd"] = pos;
      }
    },
    setCaptchaToken: function setCaptchaToken(that, callback) {
      if (gl(that) && typeof grecaptcha != "undefined") {
        grecaptcha.ready(function () {
          var siteKey = "6LdKtasUAAAAAJ473vYTeiOOGcaDBzORVUTLnbXR",
              options = {
            action: "homepage"
          };
          grecaptcha.execute(siteKey, options).then(function (token) {
            that.attr("value", token);
            _vars["captchaToken"][token] = Date.now();
            π.helper.applyMethod(callback);
          });
        });
      } else {
        π.helper.applyMethod(callback);
      }
    },
    getFormData: function getFormData(form) {
      if (form["length"]) {
        var wrapper = $(form),
            data = {};

        if (wrapper.find(".form-array")["length"]) {
          data["form-array"] = [];
          wrapper.find(".form-array").each(function (i) {
            data["form-array"][i] = π.helper.getFormData($(this));
          });
        }

        wrapper.find("input[name], textarea[name]").each(function (i) {
          if (!$(this).closest(".form-array")["length"] || wrapper.hasClass("form-array")) {
            if (this.type == "checkbox" || this.type == "radio") {
              if (this["checked"]) {
                if (typeof data[this["name"]] == "string") {
                  data[this["name"]] = [this["value"]];
                } else if (typeof data[this["name"]] == "object") {
                  data[this["name"]].push(this["value"]);
                } else {
                  data[this["name"]] = this["value"];
                }
              }
            } else {
              data[this["name"]] = this["value"];
            }
          }
        });
        wrapper.find("select[name]").each(function () {
          if (!$(this).closest(".form-array")["length"] || wrapper.hasClass("form-array")) {
            data[this["name"]] = $(this).val();
          }
        });
        return data;
      } else {
        return {};
      }
    },
    getFileName: function getFileName(input) {
      var name = input["value"].split("/").pop().split("\\").pop();
      return name.substring(0, name.lastIndexOf("."));
    },
    // objects
    _form: {
      // methods
      init: function init() {
        PRIV.init();
      },
      onDOMNodeInserted: function onDOMNodeInserted() {
        PRIV.upload.init();
        PRIV.select.init();
        PRIV.uniform.init();
        PRIV.textarea.init();
        PRIV.placeholder.init();
      },
      onReactRender: function onReactRender() {
        PRIV.upload.init();
        PRIV.select.init();
        PRIV.uniform.init();
        PRIV.textarea.init();
        PRIV.placeholder.init();
      },
      onReactSetState: function onReactSetState() {
        PRIV.upload.init();
        PRIV.select.init();
        PRIV.uniform.init();
        PRIV.textarea.init();
        PRIV.placeholder.init();
      }
    }
  };
}());;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {},
      PRIV = {},
      _refs = {},
      _vars = {}; // PUBLIC

  return {
    // methods
    getParsedJSON: function getParsedJSON(str) {
      if (typeof str == 'string') {
        try {
          return JSON.parse(str);
        } catch (err) {
          return str;
        }
      } else {
        return str;
      }
    },
    getStringifiedJSON: function getStringifiedJSON(json) {
      if (typeof json == 'object') {
        return JSON.stringify(json);
      } else {
        return json;
      }
    },
    getDecodedParsedJSON: function getDecodedParsedJSON(str) {
      return π.helper.getParsedJSON(decodeURIComponent(str));
    },
    getEncodedStringifiedJSON: function getEncodedStringifiedJSON(json) {
      return encodeURIComponent(π.helper.getStringifiedJSON(json));
    }
  };
}());;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {},
      PRIV = {
    init: function init() {
      PRIV.initStats();
      PRIV.initAjax();
      PRIV.initData();
      PRIV.initConsole();
      PRIV.initAnimationFrame();
      PRIV.checkJavaScript();
      PRIV.checkDevice();
      PRIV.checkPlattform();
      PRIV.checkUserAgent();
      PRIV.checkEnvironment();
    },
    initStats: function initStats() {
      if (π.main.config['stats']) {
        var stats = new Stats();
        stats.showPanel(0);
        stats['dom']['style']['top'] = '20px';
        stats['dom']['style']['left'] = 'auto';
        stats['dom']['style']['right'] = '20px';
        document.body.appendChild(stats.dom);
        requestAnimationFrame(function loop() {
          stats.update();
          requestAnimationFrame(loop);
        });
      }
    },
    initAjax: function initAjax() {
      $.ajaxSetup({
        contentType: 'application/json'
      });
      $(document).ajaxSend(function (event, jqxhr, settings) {
        jqxhr.setRequestHeader('X-CSRF-Token', π.helper.getCookie('csrf'));
      });
      var post = $.post;

      $.post = function (url, data, success, dataType) {
        if (typeof data == 'object') {
          data = JSON.stringify(data);
        }

        return post(url, data, success, dataType);
      };

      π.main.refs.document.ajaxError(function (event, jqxhr, settings, thrownError) {
        if (jqxhr['responseJSON'] && jqxhr['responseJSON']['redirect']) {
          location['href'] = jqxhr['responseJSON']['redirect'];
        }
      });
    },
    initData: function initData() {
      window.gv = π.helper.getValue;
      window.gl = π.helper.getLength;
    },
    initConsole: function initConsole() {
      window.log = function () {
        if (π.helper.isFunction(window, 'console.log')) {
          console.log.apply(console, arguments);
        }
      };

      window.mlog = function () {
        var args = '';

        _.each(arguments, function (val) {
          args += val + ' ';
        });

        if ($('#on-screen-log')['length']) {
          $('#on-screen-log').prepend('<li>' + args + '</li>');
        } else {
          $('body').append('<ul id="on-screen-log" style="position:fixed; top:0; left:0; max-width:100%; max-height:100%; z-index:99999999; padding:10px; border:1px solid #000; background:#fff; color:#000; overflow:scroll;"><li>' + args + '</li></ul>');
        }
      };

      if (π.helper.isObject(window, 'console')) {
        window.console.save = function (data, filename) {
          if (data) {
            if (!filename) {
              filename = 'console.json';
            }

            if (typeof data == 'object') {
              data = JSON.stringify(data, undefined, 4);
            }

            var blob = new Blob([data], {
              type: 'text/json'
            }),
                e = document.createEvent('MouseEvents'),
                a = document.createElement('a');
            a.download = filename;
            a.href = window.URL.createObjectURL(blob);
            a['dataset']['downloadurl'] = ['text/json', a['download'], a['href']].join(':');
            e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            a.dispatchEvent(e);
          }
        };
      }
    },
    initAnimationFrame: function initAnimationFrame() {
      window.requestAnimFrame = function (callback) {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function () {
          return window.setTimeout(callback, 1000 / 60);
        };
      }();

      window.cancelAnimationFrame = function (id) {
        return window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.msCancelAnimationFrame || function () {
          return window.clearTimeout(id);
        };
      }();
    },
    checkJavaScript: function checkJavaScript() {
      π.main.refs.html.removeClass('no-js').addClass('js');
    },
    checkDevice: function checkDevice() {
      if ('ontouchstart' in window) {
        π.main.refs.html.addClass('isTouch');
      }
    },
    checkPlattform: function checkPlattform() {
      if (navigator['platform'].match(/(Mac)/)) {
        π.main['device']['isMac'] = true;
        π.main.refs.html.addClass('isMac');
      }

      if (navigator['platform'].match(/(Win)/)) {
        π.main['device']['isWin'] = true;
        π.main.refs.html.addClass('isWin');
      }
    },
    checkUserAgent: function checkUserAgent() {
      if (navigator['userAgent'].match(/(Android)|(iPod)|(iPad)|(iPhone)|(BlackBerry)|(IEMobile)/i)) {
        π.main['device']['isMobile'] = true;
        π.main.refs.html.addClass('isMobile');
      }

      if (navigator['userAgent'].match(/(iPod)|(iPad)|(iPhone)/i)) {
        π.main['device']['isIOS'] = true;
        π.main.refs.html.addClass('isIOS');

        if (navigator['userAgent'].match(/(iPad)/i)) {
          π.main['device']['isIPad'] = true;
          π.main.refs.html.addClass('isIPad');
        }

        if (navigator['userAgent'].match(/(CriOS)/i)) {
          π.main['device']['isChrome'] = true;
          π.main['device']['isIOSChrome'] = true;
          π.main.refs.html.addClass('isChrome isIOSChrome');
        } else if (navigator['userAgent'].match(/(FxiOS)/i)) {
          π.main['device']['isFirefox'] = true;
          π.main['device']['isIOSFirefox'] = true;
          π.main.refs.html.addClass('isFirefox isIOSFirefox');
        } else if (navigator['userAgent'].match(/(Safari)/i)) {
          π.main['device']['isSafari'] = true;
          π.main['device']['isIOSSafari'] = true;
          π.main.refs.html.addClass('isSafari isIOSSafari');
        } else {
          π.main['device']['isApp'] = true;
          π.main['device']['isIOSApp'] = true;
          π.main.refs.html.addClass('isApp isIOSApp');
        }
      } else if (navigator['userAgent'].match(/(Android)/i)) {
        π.main['device']['isAndroid'] = true;
        π.main.refs.html.addClass('isAndroid');

        if (navigator['userAgent'].match(/(Chrome)/i) && navigator['userAgent'].match(/(Version)/i)) {
          π.main['device']['isApp'] = true;
          π.main['device']['isAndroidApp'] = true;
          π.main.refs.html.addClass('isApp isAndroidApp');
        } else if (navigator['userAgent'].match(/(Chrome)/i)) {
          π.main['device']['isChrome'] = true;
          π.main['device']['isAndroidChrome'] = true;
          π.main.refs.html.addClass('isChrome isAndroidChrome');

          if (gv($.browser, 'versionNumber') < 45) {
            π.main['device']['isAndroidDeprecated'] = true;
          }
        } else {
          π.main['device']['isAndroidNative'] = true;
          π.main.refs.html.addClass('isAndroidNative');
        }
      } else if (navigator['userAgent'].match(/(IEMobile)|(MSIE)|(Trident)|(Edge)/i)) {
        if (navigator['userAgent'].match(/(Edge)/i)) {
          π.main['device']['isEdge'] = true;
          π.main.refs.html.addClass('isEdge');
        } else if (navigator['userAgent'].match(/(MSIE)/i)) {
          π.main['device']['isIE'] = true;
          π.main.refs.html.addClass('isIE');

          if (navigator['userAgent'].match(/(MSIE 10)/i)) {
            π.main['device']['isltIE11'] = true;
            π.main.refs.html.addClass('isltIE11');
          } else if (navigator['userAgent'].match(/(MSIE 9)/i)) {
            π.main['device']['isltIE11'] = true;
            π.main['device']['isltIE10'] = true;
            π.main.refs.html.addClass('isltIE11 isltIE10');
          } else if (navigator['userAgent'].match(/(MSIE 8)|(MSIE 7)/i)) {
            π.main['device']['isltIE11'] = true;
            π.main['device']['isltIE10'] = true;
            π.main['device']['isltIE9'] = true;
            π.main.refs.html.addClass('isltIE11 isltIE10 isltIE9');
          }
        }
      } else if (navigator['userAgent'].match(/(Safari)/i) && navigator['userAgent'].match(/(Chrome)/i) === null && !π.main['device']['isIOS']) {
        π.main['device']['isSafari'] = true;
        π.main.refs.html.addClass('isSafari');
      } else if (navigator['userAgent'].match(/(Firefox)/i)) {
        π.main['device']['isFirefox'] = true;
        π.main.refs.html.addClass('isFirefox');
      } else if (navigator['userAgent'].match(/(Chrome)/i)) {
        π.main['device']['isChrome'] = true;
        π.main.refs.html.addClass('isChrome');
      }
    },
    checkEnvironment: function checkEnvironment() {
      if (location['host'].includes('localhost') || location['host'].startsWith('10.0.0.')) {
        π.main['device']['isLocal'] = true;
        π.main.refs.html.addClass('isLocal');
      } else {
        π.main['device']['isProduction'] = true;
        π.main.refs.html.addClass('isProduction');
      }
    }
  },
      _refs = {},
      _vars = {}; // PUBLIC

  return {
    // objects
    _setup: {
      init: function init() {
        PRIV.init();
      }
    }
  };
}());;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {},
      PRIV = {},
      _refs = {},
      _vars = {}; // PUBLIC

  return {
    // methods
    getToday: function getToday() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '00:00:00:000';
      time = time.split(':');
      var date = new Date(),
          hours = time[0] || '00',
          minutes = time[1] || '00',
          seconds = time[2] || '00',
          milliseconds = time[3] || '000';
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes, seconds, milliseconds);
    },
    getYesterday: function getYesterday() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '00:00:00:000';
      return new Date(π.helper.getToday(time).getTime() - moment.duration(24, 'hours').asMilliseconds());
    },
    getTomorrow: function getTomorrow() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '00:00:00:000';
      return new Date(π.helper.getToday(time).getTime() + moment.duration(24, 'hours').asMilliseconds());
    },
    getDateIn: function getDateIn(val) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'milliseconds';
      return new Date(Date.now() + moment.duration(val, unit).asMilliseconds());
    }
  };
}());;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {},
      PRIV = {
    setClassOnHashChange: function setClassOnHashChange() {
      π.main.refs.body.find('[data-set-class-on-hash-change]').each(function () {
        var that = $(this),
            data = that.data('set-class-on-hash-change');
        var split = data.split("'");

        if (split['length'] == 1) {
          split = data.split('"');
        }

        var values = _.remove(split, function (str) {
          return str['length'] > 1;
        });

        if (values[1] == location['hash'].replace('#', '')) {
          that.addClass(values[0]);
        } else {
          that.removeClass(values[0]);
        }
      });
    }
  },
      _refs = {},
      _vars = {}; // PUBLIC

  return {
    // methods
    historyPushState: function historyPushState(url) {
      if (typeof history.pushState == 'function') {
        var parsedUrl = π.helper.parseUrl(url),
            hasEqualPathname = parsedUrl['pathname'] == location['pathname'],
            hasEqualQuery = parsedUrl['query'] == location['search'],
            hasEqualHash = parsedUrl['hash'] == location['hash'];

        if (!hasEqualPathname || !hasEqualQuery || !hasEqualHash) {
          history.pushState('', '', url);

          if (typeof ga == 'function' && gv(π, 'main.data.server.config.mode') == 'production') {
            ga('set', 'page', url);
            ga('send', 'pageview');
          }

          if (π.main['window']['location']['hash'] != location['hash']) {
            π.helper.onHashChange();
          }
        }
      }
    },
    changeHash: function changeHash(hash, options) {
      if (typeof hash == 'string') {
        var preventDefault = π.helper.isTrue(options, 'preventDefault'),
            scrollTop = π.main['window']['scrollTop'];

        if (hash === '') {
          π.helper.historyPushState(location['pathname'] + location['search']);
        } else {
          hash = hash.indexOf('#') === 0 ? hash : '#' + hash;

          if (location['hash'] !== hash) {
            if (preventDefault) {
              π.main['window']['scrollPreventEventOnce'] = true;
            }

            π.helper.historyPushState(hash);
          }
        }

        if (preventDefault) {
          scrollTo(0, scrollTop);
        }
      }
    },
    parseUrl: function parseUrl(url) {
      var query = _.split(url.split('?')[1], '#')[0];

      return {
        pathname: url.split('#')[0].split('?')[0],
        query: query['length'] ? '?' + query : '',
        hash: url.split('#')[1] || ''
      };
    },
    getQueryUrl: function getQueryUrl(url, query) {
      return url + (url.includes('?') ? '&' : '?') + π.helper.getQuerySerialized(query);
    },
    getQueryObject: function getQueryObject() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location['href'];

      if (url) {
        var search = url.split('?')[1],
            parameters = search ? search.split('&') : [],
            query = {};
        parameters.forEach(function (parameter) {
          var split = parameter.split('=');
          query[split[0]] = split[1];
        });
        return query;
      } else {
        return {};
      }
    },
    getQueryValue: function getQueryValue(key) {
      return gv(π.helper.getQueryObject(), key, false);
    },
    getQuerySerialized: function getQuerySerialized(query) {
      var serialized = '';

      _.each(query, function (value, key) {
        if (decodeURIComponent(value) == value) {
          serialized += key + '=' + encodeURIComponent(value) + '&';
        } else {
          serialized += key + '=' + value + '&';
        }
      });

      return _.trimEnd(serialized, '&');
    },
    onPopState: function onPopState() {
      if (!π.main['device']['isSafari'] || π.main['device']['safariPopedIntitalState']) {
        if (π.main['window']['location']['hash'] != location['hash'] || !location['hash']['length']) {
          π.main['functions']['popstateTimeout'] = setTimeout(function () {
            π.main['functions']['popstateTimeout'] = false;
            location.reload();
          }, 10);
        }
      } else {
        π.main['window']['location']['hash'] = location['hash'];
        π.main['device']['safariPopedIntitalState'] = true;
      }
    },
    onHashChange: function onHashChange(e) {
      if (π.main['functions']['popstateTimeout']) {
        clearTimeout(π.main['functions']['popstateTimeout']);
        π.main['functions']['popstateTimeout'] = false;
      }

      π.main['window']['location']['hash'] = location['hash'];
      PRIV.setClassOnHashChange();
    },
    // objects
    _url: {
      init: function init() {
        PRIV.setClassOnHashChange();
      }
    }
  };
}());;"use strict";

_.assign(π.helper, function () {
  // PRIVATE
  var CONF = {},
      PRIV = {},
      _refs = {},
      _vars = {
    charSet: {
      lowerCase: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'],
      upperCase: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      numbers: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      specials: ['^', '°', '!', '"', '§', '$', '%', '&', '/', '\\', '(', ')', '=', '?', '´', '`', '[', ']', '|', '{', '}', '€', '+', '*', '@', '#', '\'', '<', '>', ',', ';', '.', ':', '-', '_', '~']
    }
  }; // PUBLIC

  return {
    // methods
    removeDuplicates: function removeDuplicates(string, _char) {
      return string.replace(new RegExp('(\\' + _char + ')(?=\\1)', 'g'), '');
    },
    replaceAllExcept: function replaceAllExcept(string, regExpStr) {
      var regExp = new RegExp(regExpStr);
      var newString = '';

      _.each(string, function (_char2) {
        newString += _char2.match(regExp) ? _char2 : '';
      });

      return newString;
    },
    processOperation: function processOperation(current, operator, change) {
      if (!isNaN(Number(current)) && !isNaN(Number(change))) {
        if (operator == '+') {
          return current + change;
        } else if (operator == '-') {
          return current - change;
        } else if (operator == '*') {
          return current * change;
        } else if (operator == '/') {
          return current / change;
        }
      } else {
        return undefined;
      }
    },
    isCompressedString: function isCompressedString(value) {
      if (typeof value == 'string') {
        try {
          var valueDecompressed = LZString.decompressFromBase64(value),
              valueCompressed = LZString.compressToBase64(valueDecompressed),
              isCompressed = _.trimEnd(value, '=') === _.trimEnd(valueCompressed, '=');

          return isCompressed;
        } catch (err) {
          return false;
        }
      } else {
        return false;
      }
    },
    getCompressedString: function getCompressedString(value) {
      if (typeof value == 'string') {
        if (π.helper.isCompressedString(value)) {
          return value;
        } else {
          try {
            return LZString.compressToBase64(value);
          } catch (err) {
            return value;
          }
        }
      } else {
        return value;
      }
    },
    getDecompressedString: function getDecompressedString(value) {
      if (typeof value == 'string' && π.helper.isCompressedString(value)) {
        return LZString.decompressFromBase64(value);
      } else {
        return value;
      }
    },
    getCharSet: function getCharSet(categories) {
      var charSet = [];

      if (_.isArray(categories)) {
        _.each(categories, function (category) {
          if (_vars['charSet'][category]) {
            charSet = charSet.concat(_vars['charSet'][category]);
          }
        });
      } else if (_.isString(categories) && _vars['charSet'][categories]) {
        charSet = charSet.concat(_vars['charSet'][categories]);
      } else {
        _.each(_vars['charSet'], function (set) {
          charSet = charSet.concat(set);
        });
      }

      return charSet;
    },
    getUniqueId: function getUniqueId() {
      return (new Date().valueOf().toString(36) + Math.round(Math.random() * 10000000).toString(36)).substring(0, 12);
    },
    getGeoIpData: function getGeoIpData(callback) {
      $.get('https://freegeoip.net/json/').then(callback);
    },
    getRandomString: function getRandomString(length, charSets) {
      var charSet = π.helper.getCharSet(charSets);
      var randomString = '';

      for (var i = 0; i < length; i++) {
        randomString += charSet[Math.floor(Math.random() * charSet['length'])];
      }

      return randomString;
    },
    getNumberString: function getNumberString(number, digits) {
      var length = number.toString()['length'];

      if (length < digits) {
        var diff = digits - length;
        var prefix = '';

        for (var i = 0; i < diff; i++) {
          prefix += '0';
        }

        return prefix + number;
      } else {
        return number.toString();
      }
    },
    getNewPassword: function getNewPassword(charSets) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
      var charSet = π.helper.getCharSet(charSets);
      var pass = '';
      charSets = _.castArray(charSets || ['lowerCase', 'upperCase', 'numbers', 'specials']);

      for (var i = 0; i < length - charSets['length']; i++) {
        pass += charSet[_.random(charSet['length'] - 1)];
      }

      charSets.forEach(function (category) {
        var split = _.random(0, pass['length'] - 1);

        pass = pass.substr(0, split) + _vars['charSet'][category][_.random(0, _vars['charSet'][category]['length'] - 1)] + pass.substr(split, pass['length']);
      });
      return pass;
    },
    getTextLines: function getTextLines(that) {
      var wrapper = $(document.createElement('div'));
      $(wrapper).css({
        'position': 'absolute',
        'z-index': '-1',
        'width': that.width(),
        'padding-left': that.css('padding-left'),
        'padding-right': that.css('padding-right'),
        'font': that.css('font'),
        'line-height': that.css('line-height')
      }).html(that.text());
      $('body').append(wrapper);
      var lines = Math.ceil(wrapper.height() / Number(that.css('line-height').split('px')[0]));
      wrapper.remove();
      return lines;
    }
  };
}());;"use strict";

window.gv = π.helper.getValue;
window.gl = π.helper.getLength;
π.main.refs.document.ready(function () {
  _.each(['helper', 'app.modules'], function (keys) {
    _.each(gv(π, keys, false), function (that) {
      if (typeof that.init == 'function') {
        that.init();
      }
    });
  });
});;"use strict";

π.api = function () {
  // PRIVATE
  var CONF = {},
      PRIV = {},
      _refs = {},
      _vars = {}; // PUBLIC

  return {
    _refs: {},
    _vars: {},
    // methods
    get: function get(endpoint, callback) {
      $.get(π.server.getUrl() + '/controllers/cms/api.php?endpoint=' + encodeURIComponent(endpoint), callback);
    }
  };
}();;"use strict";

/*jshint ignore:start */
π.react = function () {
  // PRIVATE
  var CONF = {},
      PRIV = {},
      _refs = {},
      _vars = {}; // PUBLIC

  return {
    _refs: {},
    _vars: {},
    // methods
    render: function render(ReactComponent, container) {
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      ReactDOM.render(React.createElement(ReactComponent, {
        data: data,
        callback: callback
      }), container);
    }
  };
}();
/*jshint ignore:end */;"use strict";

π.server = function () {
  // PRIVATE
  var CONF = {},
      PRIV = {},
      _refs = {},
      _vars = {}; // PUBLIC

  return {
    _refs: {},
    _vars: {},
    // methods
    getUrl: function getUrl() {
      if (location['host'] == 'localhost') {
        return 'http://localhost/projects/p7s1p4.com/forms.prosiebensat1puls4.tv';
      } else if (location['host'] == 'test.prosiebensat1puls4.tv') {
        return 'https://test.prosiebensat1puls4.tv/forms.prosiebensat1puls4.tv';
      } else if (location['host'] == 'forms.prosiebensat1puls4.tv') {
        return 'https://forms.prosiebensat1puls4.tv';
      } else {
        return 'http://' + location['host'];
      }
    }
  };
}();
//# sourceMappingURL=basics.js.map
